// extracted by mini-css-extract-plugin
module.exports = {"layout":"layout_layout__1q3XX","content":"layout_content__2l_Qp","sidebarActive":"layout_sidebarActive__2kzTj","badge":"layout_badge__2YZ_f"};